import { useAuth } from "@/hooks/use-auth";
import { useToast } from "@/hooks/use-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { AddPermissionDTO, RequestPermissionResponse } from "@/types";

async function addPermission(
  request: AddPermissionDTO
): Promise<RequestPermissionResponse> {
  const { id, ...data } = request;
  const response = await httpRequest.put<RequestPermissionResponse>(
    `/roles/${id}/give-permissions`,
    data
  );
  return response.data;
}

export function useAddPermissionMutation() {
  const queryClient = useQueryClient();
  const refreshUser = useAuth(state => state.refreshUser);
  const { toast } = useToast();
  return useMutation({
    mutationFn: addPermission,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["roles"] }),
        queryClient.invalidateQueries({ queryKey: ["rules"] }),
        queryClient.invalidateQueries({ queryKey: ["me"] }),
        queryClient.invalidateQueries({ queryKey: ["permissions"] }),
        queryClient.invalidateQueries({ queryKey: ["clinic-modules"] }),
      ]);
      try {
        await refreshUser();
      } catch {
        toast({ title: "Acessos salvos; sessão desatualizada", description: "Recarregue a página para atualizar seus acessos.", variant: "destructive" });
      }
    },
  });
}
